import { SUCCESS_REPONSE_CODE, UNPROCESSABLE_ENTITY_RESPONSE_CODE, handleOtherResponseCode, showErrors,
         INTERVIEW_TYPES, REDIRECT, CandidateProfileJobService, CustomToastrAction, moment, saveAs, NumberFormat, ApplicationFilter} from '@/imports-files/pages/clients/jobs/candidate-profile-job';
import { CommunicationCenterOptionsService, EmailDetailsService } from '@/imports-files/pages/clients/communication/index';
import {clearRadioButtonSelection, Kanban } from '@/imports-files/pages/clients/candidates/kanban';

export async function like_dislike(value, router, setLikeDislike, setApiError, initialData, setInitialData, setFlagForRerender)
{
    var job_applicant_id = router.query.applicant_id;
    var body = {liked: value}
    var result = await new CandidateProfileJobService().like_dislike(body, job_applicant_id);
    setLikeDislike(value);

    if(result.request.status == 200)
    {
      initialData.application.liked_unliked = value;
      initialData.notes = result.data.notes
      setInitialData(initialData);
      setFlagForRerender(Math.random() * 10000);
    }
    else
    {
      setApiError(result.request)
    }
}


export async function restricted_like_dislike(value, router, setLikeDislike, setApiError, initialData, setInitialData, setFlagForRerender)
{
    var token  = router.query.token;
    var body   = {'liked': value, 'token': token};
    var result = await new CandidateProfileJobService().restrictedLikeDislike(body);
    setLikeDislike(value);

    if(result.request.status == 200)
    {
      initialData.application.liked_unliked = value;
      initialData.notes = result.data.notes;
      setInitialData(initialData);
      setFlagForRerender(Math.random() * 10000);
    }
    else
    {
      setApiError(result.request)
    }
}


export function goToOtherCandidate(router, applicant_id, query, type, candidateCurrentStageId)
{
    if (type == 'next'){
      if(query.candidate_index && candidateCurrentStageId == parseInt(query.job_stage_id)){
        let index = parseInt(query.candidate_index);
        index = index + 1;
        query.candidate_index = index.toString();
      }
    }else{
      if(query.candidate_index && candidateCurrentStageId == parseInt(query.job_stage_id)){
        let index = parseInt(query.candidate_index);
        index = index - 1;
        query.candidate_index = index.toString();
      }
    }
    if(applicant_id)
    {
        var path = REDIRECT.client.jobs.candidate_profile_job.replace('$job_id', query.job_id).replace('$applicant_id',applicant_id);
        router.push({
                        pathname: path,
                        query: query
                    })
    }
}

export function candidateDownloadCV(url)
{
    if(url)
    {
        saveAs(url, 'Resume.pdf');
    }
    else
    {
      new CustomToastrAction().setNormalToastr('CV does not exists', 'error');
      // toastr.error('CV does not exists');
    }
}
export function getButtonStyle (condition) {
  return {
    cursor: condition ? "not-allowed" : "pointer",
    opacity: condition ? 0.5 : 1
  }
};
export function candidateOpenEmail(setShowCandidateEmail, candidate_email, setReplyTo, setReplySubject, setEmailType, setIsActiveEmail, initialData, setOpenFrom, type, setReferences)
{
    if(candidate_email || initialData.application.agency_detail)
    {
        setReplyTo('')
        if(setReferences) setReferences('')
        setReplySubject('');
        setOpenFrom(type)
        setEmailType('job_application')
        setIsActiveEmail(false)
        setShowCandidateEmail(true);
    }
    else
    {
        new CustomToastrAction().setNormalToastr('Email does not exists', 'error');
        // toastr.error('Email does not exists');
    }
}

export function candidateShareCV(setButtonPopup, cv_url)
{
    if(cv_url)
    {
        setButtonPopup(true);
    }
    else
    {
        new CustomToastrAction().setNormalToastr('CV does not exists', 'error');
        // toastr.error('CV does not exists');
    }
}

export async function submitCandidateNote(values, router, setMentionsInputValue, mentionsMember, initialData, setInitialData, setApiError, setFlagForRerender, formik)
{
    const message = document.querySelector('.autocompleteInput textarea').value;
    let body    =   {message: message, member_tag_ids: mentionsMember, private: values.private};
    let result  =   await new CandidateProfileJobService().addNote(body, router.query.applicant_id);
    router.query['section'] =  'notes';
    initialData.notes = result.data.notes
    setInitialData(initialData);
    delete(router.query['section']);
    setFlagForRerender(Math.random() * 10000);
    result.request.status != 200 ? setApiError(result.request) : null;
    formik.current.resetForm();
}


export async function submitRestrictedCandidateNote(values, router, mentionsMember, initialData, setInitialData, setApiError, setFlagForRerender, formik)
{
    const message   =  document.querySelector('.autocompleteInput textarea').value;
    var token       =   router.query.token
    let body        =   {message: message, member_tag_ids: mentionsMember, private: values.private, token: token};
    let result      =   await new CandidateProfileJobService().restrictedAddNote(body);
    initialData.notes = result.data.notes
    setInitialData(initialData);
    delete(router.query['section']);
    setFlagForRerender(Math.random() * 10000);
    result.request.status != 200 ? setApiError(result.request) : null;
    formik.current.resetForm();
}

export function getShareComponentMemberListArray(hash)
{
    var names_hash = [];

    if(hash)
    {
        for(var element of hash)
        {
            names_hash.push( {
                            id : element.user_attributes.id,
                            display: `@${element.user_attributes.name}`
                            })
        }
    }
    return names_hash;
}

export async function getCandidateProfileJobData(router, setApiError)
{
    let filterData = ApplicationFilter(router.query.job_id);
    if(filterData){
      router.query = { ... router.query, ...filterData }
    }
    let result = await new CandidateProfileJobService().getApplicationsData(router.query);
    if(setApiError) setApiError(result.request)
    return result.data;
}


export async function getCandidateRestrictedProfileJobData(router)
{
        let result = await new CandidateProfileJobService().getApplicationsDataWhenRestricted(router.query);
        if(result.request.status!= 200)
        {
            router.push(REDIRECT.client.login);
        }
        return result.data;
}

export async function getCandidateGeneralProfile(router, setApiError)
{
    router.query['general_view'] = true;
    let result = await new CandidateProfileJobService().getCandidateGeneralViewData(router.query);
    if(setApiError) setApiError(result.request)
    return result.data;
}

export async function resendInvite(meetingId, interview_type, router, setInitialData, initialData)
{
  let result                  =   await new CandidateProfileJobService().resendInvite(meetingId, interview_type);
  const  status_code          =   result.status || result.response.status;
  const customToastrAction    =   new CustomToastrAction();
  switch (status_code)
  {
    case SUCCESS_REPONSE_CODE:
      let response_data = result.data
      if(initialData) response_data.previous_record_id = initialData?.previous_record_id
      if(initialData) response_data.next_record_id = initialData?.next_record_id
      if(setInitialData) await setInitialData(response_data)
      customToastrAction.setNormalToastr(result.data.success, 'success');
      break;
    case UNPROCESSABLE_ENTITY_RESPONSE_CODE:
      customToastrAction.setNormalToastr(result.response.data.error, 'error');
      break;
    default:
      handleOtherResponseCode(status_code, router);
  }
}
export async function rescheduleInerview(values, meetingId, setBtnPopup, router, setInitialData){
  const params                =    {custom_meeting_period: values}
  let result                  =    await new CandidateProfileJobService().rescheduleInerview(params, meetingId);
  const  status_code          =    result.status || result.response.status;
  const customToastrAction    =    new CustomToastrAction();

  switch (status_code)
  {
    case SUCCESS_REPONSE_CODE:
      setBtnPopup(false)
      setInitialData(result.data)
      customToastrAction.setNormalToastr(result.data.success, 'success');
      return result.data
    case UNPROCESSABLE_ENTITY_RESPONSE_CODE:
      customToastrAction.setNormalToastr(result.response.data.error, 'error');
      break;
    default:
      handleOtherResponseCode(status_code, router);
  }
}

export async function getMeetingDetails(params, router, action){
  let result                  =   await new CandidateProfileJobService().getDetails(params, action);
  const  status_code          =   result.status || result.response.status;
  const customToastrAction    =   new CustomToastrAction();

  switch (status_code)
  {
    case SUCCESS_REPONSE_CODE:
      return result.data
    case UNPROCESSABLE_ENTITY_RESPONSE_CODE:
      customToastrAction.setNormalToastr(result.response.data.error, 'error');
      break;
    default:
      handleOtherResponseCode(status_code, router);
  }
}

export function validateForm(formik, index, start_time)
{
  let values = formik.values.children_attributes
  if(index == 0) return true
  let prevIndex;
  values.map((x, itemIndex) => {
    if(!x._destroy && itemIndex < index){
      prevIndex = itemIndex
    }
    return x;
  })
  if(typeof prevIndex === 'undefined') return true;
  let end_time = values[prevIndex].end_time
  if(end_time.length == 0) return true
  let isValid = moment(start_time, "DD/MM/YYYY HH:mm").isAfter(moment(end_time, "DD/MM/YYYY HH:mm")) && moment(start_time, "DD/MM/YYYY").isSame(moment(end_time, "DD/MM/YYYY"))
  if(isValid)
  {
     formik.setStatus({}, true)
     formik.setTouched({}, true)
  }
  else{
    let children_attributes = []
     children_attributes[index]= {
      start_time: "start time should greater than last round's end time and with same date"
     }
    formik.setStatus({children_attributes: children_attributes}, true)
     formik.setTouched({children_attributes: children_attributes}, true)
  }
}

export async function addManualInterview(params, router, setBtnPopup, setInitialData, setLoading, current_interview_type, setFlagForRender, setDisabledSaveButton, from=null, setAddInterviewBar=null, addInterviewBar=null, emailContent=null, setUnsuccessfulEmailModal=null)
{
  const kanban_params = {}
  setLoading(true)
  setDisabledSaveButton(true);
  if(current_interview_type == INTERVIEW_TYPES.FACE2FACE){
    params.children_attributes = params.children_attributes.map((x) => {
      x.location_attributes = { full_address: params.default_location || '', place_id: params.place_id || ''}
      return x
    })
  }
  if(current_interview_type != INTERVIEW_TYPES.FACE2FACE) params.children_attributes.map((x) => {
    x.location = ''
    x.place_id = ''
    x.start_time = x.date+" "+x.starttime
    x.end_time = x.date+" "+x.endtime
  })

  if(current_interview_type != INTERVIEW_TYPES.VIDEOQA) params.children_attributes.map((x) => {
    x.start_time = x.date+" "+x.starttime
    x.end_time = x.date+" "+x.endtime
  })
  
  if(current_interview_type == INTERVIEW_TYPES.VIDEOQA)
  {
    params['job_stage_id'] = router.query.job_stage_id;
    params['job_stage_attributes']['id'] = router.query.job_stage_id
    params['job_stage_attributes']['job_id'] = router.query.job_id;
    params['member_emails'] = params.videoqa.member_emails;
    // params['job_stage_attributes']['stage_id'] = 3;  //TODO
  }
  if(emailContent){
    params["email"] = emailContent
  }
  const data                  =   { job_application_meeting: params }
  if (from == 'application_view'){
    data.kanban = {candidate_index: router?.query?.candidate_index, base_stage_id: router?.query?.job_stage_id }
    let filterData = ApplicationFilter(router.query.job_id);
    if(filterData){
      data.application_filter_data = filterData;
    }
  }

  let result                  =   await new CandidateProfileJobService().addInterview(data);
  const  status_code          =   result.status || result.response.status;
  const customToastrAction    =   new CustomToastrAction();
  setLoading(false)

   switch (status_code)
  {
    case SUCCESS_REPONSE_CODE:
      setBtnPopup({active: false, action: ''})
      setInitialData(result.data)
      setFlagForRender(Math.random() * 10000);
      setDisabledSaveButton(false);
      setAddInterviewBar({ active: false, action: {}})
      if (setUnsuccessfulEmailModal) setUnsuccessfulEmailModal({state: false})
      if(result.data.success) customToastrAction.setNormalToastr(result.data.success, 'success')
      return result.data
    case UNPROCESSABLE_ENTITY_RESPONSE_CODE:
      let error_message = showErrors(result.response.data.error)
      error_message.length > 0 ? customToastrAction.setNormalToastr(error_message, 'error')
                               : customToastrAction.setNormalToastr(result.response.data.error, 'error');
      setDisabledSaveButton(false);
      if (setUnsuccessfulEmailModal) setUnsuccessfulEmailModal({state: false})
      break;
    default:
      handleOtherResponseCode(status_code, router);
      setDisabledSaveButton(false);
  }
}

export async function addManualKanbanInterview(params, router, setBtnPopup, setInitialData, setLoading, current_interview_type, setFlagForRender, setDisabledSaveButton, args, setAddInterviewBar=null, addInterviewBar=null, emailContent=null, setUnsuccessfulEmailModal=null )
{
  setDisabledSaveButton(true);
  setLoading(true)
  if(current_interview_type == INTERVIEW_TYPES.FACE2FACE){
    params.children_attributes = params.children_attributes.map((x) => {
      x.location_attributes = { full_address: params.default_location || '', place_id: params.place_id || ''}
      return x
    })
  }
  if(current_interview_type != INTERVIEW_TYPES.FACE2FACE) params.children_attributes.map((x) => {
    x.location = ''
    x.place_id = ''
    x.start_time = x.date+" "+x.starttime
    x.end_time = x.date+" "+x.endtime
  })

  if(current_interview_type != INTERVIEW_TYPES.VIDEOQA) params.children_attributes.map((x) => {
    x.start_time = x.date+" "+x.starttime
    x.end_time = x.date+" "+x.endtime
  })

  if(current_interview_type == INTERVIEW_TYPES.VIDEOQA)
  {
    params['job_stage_id'] = args.selectedCards.stage_id;
    params['job_stage_attributes'] = { id: args.selectedCards.stage_id }
    params['job_stage_attributes']['job_id'] = router.query.job_id;
    params['member_emails'] = params.videoqa.member_emails;
  }

  if(current_interview_type == INTERVIEW_TYPES.TECHTEST)
  {
    params.assessment = params.job_test_detail_attributes.assessment
    params['job_stage'] = {job_test_detail_attributes: params.job_test_detail_attributes }
    params.assessment = params.job_test_detail_attributes.assessment
    // params['job_stage_attributes'] = { id: args.selectedCards.stage_id }
    // params['job_stage_attributes']['job_id'] = router.query.job_id;
    // params['member_emails'] = params.videoqa.member_emails;
  }
  if(emailContent){
    params["email"] = emailContent
  }

  const data                  =   { job_application_meeting: params, from: args.from }
  data.job_application_meeting.job_application_ids = args.selectedCards.job_application_ids
  data.job_application_meeting.rejected_ids = args.selectedCards.rejected_ids
  data.job_application_meeting.job_stage_id = args.selectedCards.stage_id
  if (args.from == 'application_view'){
    data.kanban = { candidate_index: args.candidateIndex, base_stage_id: args.paramStageId}
  }

  let result                  =   await new CandidateProfileJobService().setupInterview(data);
  const  status_code          =   result.status || result.response.status;
  const customToastrAction    =   new CustomToastrAction();
  setLoading(false)

  switch (status_code)
  {
    case SUCCESS_REPONSE_CODE:
      setBtnPopup(false)
      if(args.from == 'kanban'){
        clearRadioButtonSelection(args.setSelectedCards, args.activeTab, args.setActionBar)
        setInitialData(result.data.kanban_data)
      }
      else{
        setInitialData(result.data.application_data)
      }
      // setFlagForRender(Math.random() * 10000);
      setDisabledSaveButton(false);
      setAddInterviewBar({ active: false, action: {}})
      if (setUnsuccessfulEmailModal) setUnsuccessfulEmailModal({state: false})
      // if(result.data.success) customToastrAction.setNormalToastr(result.data.success, 'success')
      return result.data
    case UNPROCESSABLE_ENTITY_RESPONSE_CODE:
      let error_message = showErrors(result.response.data.error)
      error_message.length > 0 ? customToastrAction.setNormalToastr(error_message, 'error')
                               : customToastrAction.setNormalToastr(result.response.data.error, 'error');
      setDisabledSaveButton(false);
      break;
    default:
      handleOtherResponseCode(status_code, router);
      setDisabledSaveButton(false);
  }
}



export async function viewDetails(meetingId, router)
{
  let result                  =   await new CandidateProfileJobService().viewDetails(meetingId);
  const  status_code          =   result.status || result.response.status;
  const customToastrAction    =   new CustomToastrAction();

  switch (status_code)
  {
    case SUCCESS_REPONSE_CODE:
      return result.data
    case UNPROCESSABLE_ENTITY_RESPONSE_CODE:
      customToastrAction.setNormalToastr(result.response.data.error, 'error');
      break;
    default:
      handleOtherResponseCode(status_code, router);
  }
}

export async function cancelDocumentAction(contract_id, router, setInitialData) {
  let result = await new CandidateProfileJobService().cancelDocumentAction(contract_id);
  const status_code = result.status || result.response.status;
  const customToastrAction = new CustomToastrAction();
  switch (status_code) {
    case SUCCESS_REPONSE_CODE:
      setInitialData(result.data);
      customToastrAction.setNormalToastr(result.data.success, "success");
      return result.data;
    case UNPROCESSABLE_ENTITY_RESPONSE_CODE:
      customToastrAction.setNormalToastr(result.response.data.error, "error");
      break;
    default:
      handleOtherResponseCode(status_code, router);
  }
}

export async function viewRequest(meetingId, router){
  let result                  =   await new CandidateProfileJobService().viewRequest(meetingId);
  const  status_code          =   result.status || result.response.status;
  const customToastrAction    =   new CustomToastrAction();

  switch (status_code)
  {
    case SUCCESS_REPONSE_CODE:
      return result.data
    case UNPROCESSABLE_ENTITY_RESPONSE_CODE:
      customToastrAction.setNormalToastr(result.response.data.error, 'error');
      // toastr.error(result.response.data.error)
      break;
    default:
      handleOtherResponseCode(status_code, router);
  }
}

export async function cancelInterviewByClient(values, meetingId, setBtnPopup, router, setInitialData, setFlagForRender)
{
  const data                  =   {cancel_detail: values}
  let result                  =   await new CandidateProfileJobService().cancelInterview(data, meetingId);
  const  status_code          =   result.status || result.response.status;
  const customToastrAction    =   new CustomToastrAction();

  switch (status_code)
  {
    case SUCCESS_REPONSE_CODE:
      setBtnPopup(false);
      setInitialData(result.data);
      customToastrAction.setNormalToastr(result.data.success, 'success');
      // toastr.success(result.data.success)
    case UNPROCESSABLE_ENTITY_RESPONSE_CODE:
      customToastrAction.setNormalToastr(result.response.data.error, 'error');
      // toastr.error(result.response.data.error)
      break;
    default:
      handleOtherResponseCode(status_code, router);
  }
}

export async function checkAvailability(values, meetingId, router, setNoOfSlots)
{
  const data                  =   {start_date: values.start_date.replaceAll('/', '-'), end_date: values.end_date.replaceAll('/', '-')}
  let result                  =   await new CandidateProfileJobService().getNoOfSlots(data, meetingId);
  const  status_code          =   result.status || result.response.status;
  const customToastrAction    =   new CustomToastrAction();

  switch (status_code)
  {
    case SUCCESS_REPONSE_CODE:
      setNoOfSlots(result.data.available_slots)
      // toastr.success(result.data.success)
      break;
    case UNPROCESSABLE_ENTITY_RESPONSE_CODE:
      customToastrAction.setNormalToastr(result.response.data.error, 'error');
      // toastr.error(result.response.data.error)
      break;
    default:
      handleOtherResponseCode(status_code, router);
  }
}

export async function acceptSlot(meetingId, preferenceId, setBtnPopup, router, setInitialData, setShowLoader) {
    setShowLoader(true);
  const data                  =   {preference_id: preferenceId}
  let result                  =   await new CandidateProfileJobService().acceptSlotRequest(data, meetingId);
  const  status_code          =   result.status || result.response.status;
  const customToastrAction    =   new CustomToastrAction();
  setShowLoader(false);
  switch (status_code)
  {
    case SUCCESS_REPONSE_CODE:
      setInitialData(result.data);
      setBtnPopup(false);
      customToastrAction.setNormalToastr(result.data.success, 'success');
      // toastr.success(result.data.success)
      break;
    case UNPROCESSABLE_ENTITY_RESPONSE_CODE:
      customToastrAction.setNormalToastr(result.response.data.error, 'error');
      // toastr.error(result.response.data.error)
      break;
    default:
      handleOtherResponseCode(status_code, router);
  }
}

export function setTabValue(router, initialData)
{
  if(router.query?.tab && router.query?.tab == 'scorecard')
  {
    return 2
  }
  else if(router.query?.comm_section == 'comms')
    return 1
  else if(router.query?.selected_section == 'offer' || (initialData?.offer_stage_id == initialData?.application?.stage_id))
    return initialData.technical_tests ? '7' : '6'
  else
    return 0
}

export function mergeCandidate(candidate_id, candidate_name, router)
{
  let params = router.query
  params['query'] = candidate_name.split(' ')[0];
  let link = REDIRECT.client.jobs.merge_listing.replace('$candidate_id', candidate_id);
  router.push({pathname:link, query: params})
}


export async function markAsReadEmail(record) {
  const communicationCenterOptionsService = new CommunicationCenterOptionsService();
  const params = { ids: [record.user_comm_detail_id].concat(record.child_ids), read: true }
  params.comms_tab = true
  var result = await communicationCenterOptionsService.markAsRead(params);
}

export async function downloadContract(contract_id, contract_title) {
  const customToastrAction = new CustomToastrAction();
  var result = await new CandidateProfileJobService().downloadContract(
    contract_id
  );
  if (result.status == 200) {
    saveAs(result.data, `${contract_title}.${result.data.type.split("/")[1]}`);
  } else {
    customToastrAction.setNormalToastr(
      "Something went wrong, please try again later",
      "error"
    );
  }
}

export async function previewContract(contract_id){
  var result =   await new CandidateProfileJobService().previewContract(contract_id);
  if(result.request.status == 200){
    window.open(result.data.file_url, '_blank')
  }
}

  export function showAddScorecard(){
    document.getElementsByClassName("job-application-view-section")[0].classList.add('displaynone')
    document.getElementsByClassName("add-scorecard-section")[0].classList.remove('displaynone')
  }
  export function hideAddScorecard(){
    document.getElementsByClassName("job-application-view-section")[0].classList.remove('displaynone')
    document.getElementsByClassName("add-scorecard-section")[0].classList.add('displaynone')
  }

export class AddInterviewManualAction
{

  constructor(setFlagForRerender, deleteQuestionList, setDeleteQuestionList, setDisabledAddMoreQuestion)
{
  this.setFlagForRerender = setFlagForRerender;
  this.deleteQuestionList  = deleteQuestionList;
  this.setDeleteQuestionList  = setDeleteQuestionList;
  this.setDisabledAddMoreQuestion = setDisabledAddMoreQuestion;
  }

  NumberField({field, className, disabled, format, placeholder, style, formik,isAllowed, onValueChange, defaultValue}) {

    return <NumberFormat {...field} 
      defaultValue={defaultValue}
      thousandsGroupStyle="thousand"
      name={field.name}
      format={format}
      displayType="input"
      type="text"
      className={className}
      style={style}
      formik={formik}
      disabled={disabled}
      placeholder={placeholder}
      thousandSeparator={true}
      allowNegative={false}
      isAllowed={isAllowed}
      onValueChange={onValueChange}
    />
  }

  setLanguageList(data)
  {
    let list_data = [];
    if(data)
    {
      for(let key of Object.keys(data))
      {
        list_data.push({value: data[key].title, label: data[key].title})
      }
    }
    return list_data;
  }

  onAddClick(formik)
  {
      formik.values.questions_attributes.push({question: '', description: '', attempts: 2, answer_time: 30, _destroy: false})
      this.setFlagForRerender(Math.random()*10000)

    if(formik.values.questions_attributes.length == 5)
    {
      this.setDisabledAddMoreQuestion(true);
    }

  }

  onDeleteClick(formik, index)
  {
    this.deleteQuestionList.push(formik.values.questions_attributes[index])
    this.deleteQuestionList[this.deleteQuestionList.length - 1]['_destroy'] = true
    this.setDeleteQuestionList(this.deleteQuestionList);
    this.setDisabledAddMoreQuestion(false);
    formik.values.questions_attributes.splice(index, 1);
    this.setFlagForRerender(Math.random()*10000)
  }

  setQuestionsValues(values)
  {
    values.questions_attributes = Object.assign( [], values.questions_attributes, this.deleteQuestionList)
    return values;
  }
}
